import { render } from "./Sent.vue?vue&type=template&id=4b299b82&ts=true"
import script from "./Sent.vue?vue&type=script&lang=ts"
export * from "./Sent.vue?vue&type=script&lang=ts"

import "./Sent.vue?vue&type=style&index=0&id=4b299b82&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__